// extracted by mini-css-extract-plugin
export default {"TableRow":"table-row_TableRow__Qylph","TableRow__text":"table-row_TableRow__text__hpnQm","TableRow__price":"table-row_TableRow__price__eBj9M"};